interface PageProps {
  title: string
  note?: string
  children?: React.ReactNode
}

/** Simple scaffold page used by routes not yet implemented. */
export function Page({ title, note, children }: PageProps) {
  return (
    <section className="pt-4">
      <h1 className="text-xl font-semibold">{title}</h1>
      {note ? <p className="mt-1 text-sm text-slate-400">{note}</p> : null}
      <div className="mt-4">{children}</div>
    </section>
  )
}
